<script setup lang="ts">
import { ArrowUpCircle } from 'lucide-vue-next'
import type { Elemental } from '~~/src/types/elemental'
import { Button } from '@/components/ui/button'
import { useGetElementalInfosQuery } from '~~/src/composables/query/elementals/useGetElementalInfosQuery'
import { formatThousands } from '@/utils/formatting'
const props
  = defineProps<IProps>()

defineOptions({
  name: 'ElementalUpvote',
})

interface IProps {
  element: Elemental
  hiddeCount?: boolean
  feedView?: boolean
  rounded?: boolean
}
const firebaseUser = useUser()
const isAuth = computed(() => firebaseUser.value !== null)
const { element } = toRefs(props)
const { data, isLoading, refetch } = useGetElementalInfosQuery({ id: props.element.id, query: { fields: 'full' } }, { enabled: isAuth })
const { isPending, upvote } = useUpvote(element, data)
const isDisabled = computed(() => isPending.value || isLoading.value)

const count = computed(() => props.hiddeCount ? undefined : data.value?.counts?.votes !== undefined ? formatThousands(data.value?.counts?.votes) : undefined)

watch(firebaseUser, () => {
  if (firebaseUser.value !== null)
    refetch()
})
</script>

<template>
  <Button
    type="button"
    :size="feedView ? 'sm' : 'default'"
    variant="snack-ghost"
    role="checkbox"
    :disabled="isDisabled"
    :aria-label="data?.isVoted ? 'Remove vote' : 'Upvote'"
    :aria-checked="data?.isVoted"
    :title="data?.isVoted ? 'Remove Vote' : 'Upvote'"
    class="bg-white text-soft-black px-2"
    :class="{
      '[&_svg]:w-6 [&_svg]:h-6 h-10': !hiddeCount,
      'rounded text-soft-black font-700 text-xs': feedView,
      '[&_svg]:text-elemental-prompt-color [&:hover_svg_circle]:fill-elemental-prompt-color [&:hover_svg_circle]:color-elemental-prompt-color [&:hover_svg_path]:color-white': data?.isVoted,
      'rounded-full': rounded,
    }"
    v-bind="$attrs"
    @click.prevent.stop="upvote()"
  >
    <ArrowUpCircle class="w-5 h-5" />
    {{ count }}

    <slot name="count" />
  </Button>
</template>
